<template>
  <BaseDialog
    v-if="isPhone"
    ref="dialog"
    contentClass="keywords-add"
    sidePanel
    white-content
    @closeModal="close"
    @dialog-closed="close"
    @opened="$emit('opened')"
  >
    <template slot="title">{{ $tc('page.admin-keywords.add-keywords', 0) }}</template>
    <template slot="content">
      <p class="keywords-add__category">{{ categoryName }}</p>
      <slot />
    </template>
  </BaseDialog>
  <div v-else>
    <slot />
  </div>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import { viewport } from '@/util/viewport';

// Where keywords are typed in to add to a category: under it on larger screens; on phones, a panel
// of its own (between the category cards, the box and its buttons belonged to none). The page
// renders it while adding, and hears `close` when it's dismissed (✕, back).
export default {
  name: 'KeywordsAddPanel',
  components: { BaseDialog },
  props: {
    categoryName: { type: String, default: '' },
  },
  computed: {
    isPhone() {
      return viewport.size === 'phone';
    },
  },
  mounted() {
    if (this.isPhone) this.$nextTick(() => this.$refs.dialog.openModal());
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.base-dialog__keywords-add {
  .keywords-add__category {
    margin: 0 0 $space-3;
    @include text-style('label-md');
    color: $color-text-muted;
  }

  .page-keywords__textarea {
    min-height: 96px;
  }

  // The helpers that change the text (~, Transformer) on the line under the box, the main action
  // across the panel under them, as in the other phone forms.
  .page-keywords__add-keyword-group,
  .page-keywords__add-keyword {
    flex-wrap: wrap;
    justify-content: flex-start;
    row-gap: $space-md;

    // Anything to tap is at least 44px (docs/page-layout.md).
    .base-button__element,
    .baseshortcut__box {
      min-height: 44px;
    }

    .baseshortcut__box {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 44px;
    }

    > :last-child {
      flex: 1 1 100%;
      margin: 0;

      .base-button__element {
        justify-content: center;
        width: 100%;
      }
    }
  }
}
</style>
